module.exports = __webpack_public_path__ + "img/km.6ae3468c.svg";